export default "__VITE_ASSET__xxapm0Vp__"